/**
 * @graph-stack web-design-system
 * @graph-domain UX
 * @graph-business 複数行テキスト入力コンポーネント。ネイティブ textarea にデザイントークンを適用したフォームプリミティブ
 * @graph-connects none
 */
import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../../../lib/cn';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

/** @graph-connects none */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'w-full bg-[var(--color-bg-surface)] border border-[var(--color-border)] rounded-lg text-[var(--color-text-primary)] placeholder:text-[var(--color-text-muted)] px-4 py-2 text-sm transition-all duration-[var(--transition-fast)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[var(--color-bg-base)] focus:ring-[var(--color-border-focus)] focus:border-[var(--color-border-focus)] hover:border-[var(--color-border-hover)] disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...props}
    />
  ),
);

Textarea.displayName = 'Textarea';
